import { TFunction } from 'i18next';

export const getStatusOptions = (
  translates: TFunction<'Documents', undefined>
) => [
  { name: translates('inProgress'), value: 'En Proceso' },
  { name: translates('inEditing'), value: 'En Edición' },
  { name: translates('pendingPayment'), value: 'Pendiente de Pago' },
  { name: translates('scheduled'), value: 'Agendada' },
  { name: translates('paid'), value: 'Paga' },
  { name: translates('all'), value: '' },
];

export const getTypeOptions = (
  translates: TFunction<'Documents', undefined>
) => [
  { name: translates('import'), value: 'Importación' },
  { name: translates('export'), value: 'Exportación' },
  { name: translates('depo20'), value: 'Depo20' },
  { name: translates('additionalService'), value: 'Proforma' },
  { name: translates('emptyImport'), value: 'VacíoImportación' },
  { name: translates('reimbursement'), value: 'Reintegro' },
  { name: translates('all'), value: '' },
];
